import { useIntl } from "react-intl";
import { Modal, Box, Checkbox, Typography } from "@mui/material";
import PageHeader from "../ui/PageHeader";
import { useEffect, useState } from "react";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import {
  handleError,
  errorToast,
  addDownloadLinkToDocument,
} from "../../services/serviceBase";
import CustomGridHeaderCell from "../ui/CustomGridHeaderCell";
import CustomTable from "../ui/CustomTable";
import CustomGridCell from "../ui/CustomGridCell";
import { toast } from "react-hot-toast";

const RetunFileRelatedModal = (props) => {
  const intl = useIntl();

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    boxShadow: 24,
    width: 800,
    p: 4,
    borderRadius: "5px",
  };

  const { setLoading } = useLoading();

  const [relatedRAData, setRelatedRAData] = useState([]);
  const [realatedRAColumns, setRealatedRAColumns] = useState([]);

  const [workableRAData, setWorkableRAData] = useState([]);
  const [workableRADataColumns, setWorkableRADataColumns] = useState([]);

  const getRelatedRA = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/relatedreturnfiles")
      .then((response) => {
        setLoading(false);
        setRelatedRAData(response.data);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.detail);
      });
  };

  const getWorkableRA = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/workableReturnFiles")
      .then((response) => {
        setLoading(false);
        setWorkableRAData(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getRelatedRAColumns = () => {
    setRealatedRAColumns([
      {
        field: "sequence",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Sequence" })}
          </Typography>
        ),
        flex: 0.8,
        minWidth: 80,
      },
      {
        field: "raKey",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.Key" })}
          </Typography>
        ),
        flex: 1.3,
        minWidth: 80,
      },
      {
        field: "outcome",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.QCOutcome" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 80,
      },
      {
        field: "raStatus",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.State" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 80,
      },
    ]);
  };

  const getWorkableRAData = () => {
    setWorkableRADataColumns([
      {
        field: "returnFileKey",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.Key" })}
          </Typography>
        ),
        flex: 1.3,
        minWidth: 80,
      },
      {
        field: "outcomeDescription",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.QCOutcome" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 80,
      },
      {
        field: "rfStateCode",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.State" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 80,
      },
    ]);
  };

  useEffect(() => {
    if (
      props.idReturnFileHead !== null &&
      props.idReturnFileHead !== undefined &&
      props.idReturnFileHead !== "" &&
      props.openModal
    ) {
      getRelatedRA();
      getWorkableRA();
    }
  }, [props.openModal]);

  useEffect(() => {
      getRelatedRAColumns();
  }, [relatedRAData]);

  useEffect(() => {
    getWorkableRAData();
}, [workableRAData]);

  const handleClose = () => {
    props.handleCloseModal();
    setRelatedRAData([]);
    setWorkableRAData([]);
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Box>
          <PageHeader title={intl.formatMessage({ id: "RADetails.RelatedRA" })}
          />
          <Box id="modal-modal-description" sx={{ mt: 2 }}>
            <CustomTable
              columns={realatedRAColumns}
              rows={relatedRAData}
              id={"idReturnFileHead"}
              rowHeight={40}
              headerHeight={30}
              tableHeight={200}
            />
        </Box>
        </Box>
        <Box sx={{ mt: 5 }}>
          <PageHeader title={intl.formatMessage({ id: "RADetails.WorkableRA" })}
          />
          <Box sx={{ mt: 2 }}>
            <CustomTable
              columns={workableRADataColumns}
              rows={workableRAData}
              id={"idReturnFileHead"}
              rowHeight={40}
              headerHeight={30}
              tableHeight={300}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default RetunFileRelatedModal;
